

export const queryString = paramsValue => {
    
    const params = (new URL(document.location)).searchParams
    return params.get(paramsValue)
}